// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Choose amount to deposit'"></sub-header>
    <form-section>

      <div class="info info--deposit">
        <div class="info-detail">
          <span class="key">Product name:</span>
          <span class="value">{{\$ctrl.depositAccount.productName}}
          </span>
        </div>

        <div class="info-detail">
          <span class="key">Available balance:</span>
          <span class="value"
                ng-class="{'currency--positive': \$ctrl.depositAccount.balance > 0, 'currency--negative': \$ctrl.depositAccount.balance < 0}">
            {{\$ctrl.depositAccount.balance | nxCurrency}}
          </span>
        </div>
      </div>

      <cash-amount-picker
        values="[50, 100, 150, 200, 250, 500, 1000]"
        inactive-button-class="'btn-success'"
        selected-button-class="'btn-primary'"
        on-select="\$ctrl.amountSelected(value)">
      </cash-amount-picker>

      <div class="labelled-field">
        <label for="remarks">Remarks</label>
        <input id="remarks"
               type="text"
               ng-model="\$ctrl.remarks"
               name="remarks" />
      </div>

      <div class="buttons">
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-success" ng-click="\$ctrl.deposit()" ng-disabled="!\$ctrl.selectedAmount">Deposit</button>
      </div>

      <div class="clearfix"></div>
    </form-section>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/cash-deposit/cash-deposit.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;